import { TenantEntity } from '../TenantEntity'
import {
  queryDocHistoryByTime,
  queryDocHistory,
  queryReceiptHistory,
  queryDocHistoryJsonFunc
} from '@/api/booking/checkCargoDocHistory'

export class CheckCargoDocHistory extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get timestamp() {
    return this._data.timestamp
  }
  set timestamp(timestamp) {
    this._data.timestamp = timestamp || 0
  }
  get fieldName() {
    return this._data.fieldName
  }
  set fieldName(fieldName) {
    this._data.fieldName = fieldName
  }
  get fieldValue() {
    return this._data.fieldValue
  }
  set fieldValue(fieldValue) {
    this._data.fieldValue = fieldValue
  }
  get fieldType() {
    return this._data.fieldType
  }
  set fieldType(fieldType) {
    this._data.fieldType = fieldType
  }
  get cargoDocUuid() {
    return this._data.cargoDocUuid
  }
  set cargoDocUuid(cargoDocUuid) {
    this._data.cargoDocUuid = cargoDocUuid
  }
  static async queryDocHistoryByTime(cargoDocUuid) {
    return await queryDocHistoryByTime({ cargoDocUuid }).then(res => res.data)
  }
  static async queryDocHistory(cargoDocUuid) {
    return await queryDocHistory({ cargoDocUuid }).then(res => res.data)
  }
  static async queryReceiptHistory(jobUUID) {
    return await queryReceiptHistory({ jobUUID }).then(res => res.data)
  }
  static async queryDocHistoryJsonFunc(cargoDocUuid, timeStamp) {
    return await queryDocHistoryJsonFunc({ cargoDocUuid, timeStamp }).then(res => res.data)
  }
}
